/**
 * Whether a path segment could be a feedback entry's id at all.
 *
 * Feedback ids are generated UUIDs (`@PrimaryGeneratedColumn('uuid')`), so anything else in that
 * position is an address, not an id. Its own module so the namespace page can ask it without loading
 * the feedback screen.
 */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function couldBeFeedbackId(segment: string | undefined): boolean {
  return Boolean(segment && UUID.test(segment));
}
